var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AppleLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-to-Calenar-Modal-10/2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-to-your-calendar-modal",
    transform: "translate(-169.000000, -208.000000)",
    fill: "#3D4548",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.500000, 87.481475)",
    id: "Save-Button-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.000000, 109.639752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apple_logo_grey",
    transform: "translate(18.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8439938,14.0274647 C14.57178,14.656335 14.2495676,15.235206 13.8762455,15.767412 C13.3673718,16.4929452 12.9507179,16.9951523 12.6296165,17.2740335 C12.131854,17.7317969 11.5985369,17.9662343 11.027443,17.9795669 C10.6174556,17.9795669 10.123026,17.8629035 9.54748795,17.6262449 C8.9700613,17.3906951 8.4394107,17.2740335 7.95420308,17.2740335 C7.4453296,17.2740335 6.89956819,17.3906951 6.31580841,17.6262449 C5.7311589,17.8629035 5.26017344,17.9862341 4.90007319,17.9984561 C4.35242303,18.0217882 3.8065511,17.7806831 3.26167852,17.2740335 C2.91391152,16.9707083 2.47892479,16.4507244 1.95782932,15.7140798 C1.39873534,14.9274366 0.939082622,14.0152429 0.578982413,12.9752744 C0.19332748,11.8519751 0,10.7642305 0,9.71115169 C0,8.5048551 0.260658781,7.46444218 0.782754015,6.59257964 C1.19307487,5.89226789 1.73894717,5.33984017 2.4221483,4.93429659 C3.10535015,4.52875373 3.84354992,4.3220934 4.638526,4.30887132 C5.07351236,4.30887132 5.6439399,4.44342275 6.35280705,4.7078593 C7.05967458,4.97318451 7.51354978,5.10773612 7.71254337,5.10773612 C7.86131661,5.10773612 8.36552358,4.95040713 9.22027551,4.63675048 C10.0285847,4.34587031 10.710786,4.22542926 11.2696579,4.27287222 C12.7840565,4.39509077 13.9217997,4.99207281 14.6784435,6.06759562 C13.3240403,6.88823755 12.6540605,8.03764694 12.6673933,9.51215755 C12.6796151,10.6606781 13.096269,11.6164266 13.915133,12.3752931 C14.2862326,12.7275039 14.7006649,12.9997179 15.1617608,13.1930456 C15.0617652,13.4830368 14.9562129,13.7608061 14.8439938,14.0274647 Z M11.3707662,0.360102585 C11.3707662,1.26030793 11.0418868,2.10082725 10.3863516,2.87880324 C9.59526391,3.80366444 8.63840465,4.33809234 7.60076914,4.2537618 C7.58754742,4.14576486 7.57988104,4.03210189 7.57988104,3.91266127 C7.57988104,3.04846493 7.95609182,2.12360409 8.62418303,1.36740486 C8.95772788,0.984527958 9.38193728,0.666170972 9.89636628,0.412211502 C10.409684,0.162041213 10.8952249,0.023691779 11.3518774,0 C11.365211,0.120343495 11.3707662,0.24069437 11.3707662,0.360090885 L11.3707662,0.360102585 Z",
    id: "AppleLogo"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/AppleLogo.0ab31f50359c616a2de2852bcad234dd.svg";
export { ForwardRef as ReactComponent };